import {filter, get} from 'lodash-es'

export default {
  checkRequired: state => meta => {
    const { config } = meta
    return filter(config, ({ rules, checkVisible }) =>
      rules ? rules.some(rule => rule[0] === 'required' || rule === 'required') : false
    )
  },

  checkNotRequired: state => meta => {
    const { config } = meta
    return filter(config, ({ rules }) =>
      rules ? rules.every(rule => rule[0] !== 'required' && rule !== 'required') : true
    )
  },

  needRequired: (state, getters) => meta => !!getters.checkRequired(meta).length,

  checkStatus: (state, getters) => (meta, path) => {
    const fields = getters.checkRequired(meta)
    const data = get(state, path, {})
    // 没有required字段，按照非必填表单校验规则校验, 任意填了一项就认为已填
    if (!fields.length) {
      const notRequireds = getters.checkNotRequired(meta)

      return notRequireds.some(({ prop, checkVisible }) => {
        let ret = true
        if (checkVisible) {
          ret = checkVisible(data)
        }
        return ret ? (Array.isArray(data[prop]) ? data[prop].length : data[prop] != null && data[prop] !== '') : false
      })
      // return Object.entries(data).some(([key, value]) =>
      //   Array.isArray(value) ? value.length : value != null && value !== ''
      // )
    }
    // 有required字段，必填项有一个为 空/空字符串 认为未完成
    return fields.every(({ prop, checkVisible }) => {
      let ret = true
      if (checkVisible) {
        ret = checkVisible(data)
      }
      return ret ? (Array.isArray(data[prop]) ? data[prop].length : data[prop] != null && data[prop] !== '') : true
    })
  }
}
